import type {
  InvoiceV2AssigneeSuggestionsQueryParams,
  InvoiceV2AssigneeSuggestionsResponse,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import { zodInvoicePossibleAssigneesResponseSchema } from '../useQueryInvoicePossibleAssignees/validations';

import { zodInvoiceV2AssigneeSuggestionsQueryParamsSchema } from './validations';

/**
 * Fetches the users assigned to at least one invoice the caller can read, for
 * the invoice list assignee filter. Omitting the limit returns every user.
 *
 * @param queryParams - Optional search term and page window.
 * @param options - Additional request options.
 * @returns A page of users plus whether another page exists.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/suggest_assignees_invoices_suggestions_assignees_get
 */
export async function fetchInvoiceV2AssigneeSuggestions(
  queryParams: Partial<InvoiceV2AssigneeSuggestionsQueryParams>,
  options?: KyRequestOptions,
): Promise<InvoiceV2AssigneeSuggestionsResponse> {
  return vestigasApi
    .get(ENDPOINT.INVOICE.GET_ASSIGNEE_SUGGESTIONS(), {
      searchParams: queryParams,
      ...options,
      validate: {
        ...options?.validate,
        isResponseSensitive: true,
        response: zodInvoicePossibleAssigneesResponseSchema,
        searchParams:
          zodInvoiceV2AssigneeSuggestionsQueryParamsSchema.transform((data) =>
            withoutObjectKeysWhereValueIs(data, [undefined, '']),
          ),
      },
    })
    .json<InvoiceV2AssigneeSuggestionsResponse>();
}
